import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'HomeServices-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
